<template>
    <v-dialog-old @hidden="cancel" :onCloseEsc="closeModal" ref="resultDialog" :special-styles="{ width: '700px' }">
        <fieldset>
            <legend>Результаты поиска</legend>

            <div v-if="!foundFiles.length" style="margin: auto; width: max-content;">
                Ничего не найдено
            </div>

            <ul v-else>
                <li v-for="file in foundFiles">
                    {{ file }}
                </li>
            </ul>
        </fieldset>
    </v-dialog-old>
</template>

<script>
    export default {
        data: () => ({
            foundFiles: [],
        }),
        methods: {
            show(foundFiles) {
                this.foundFiles = foundFiles;
                this.$refs.resultDialog.show();
            },
            cancel() {
                this.foundFiles = [];
            },
            closeModal() {
                this.cancel();
                this.$refs.resultDialog.hide();
            },
        },
    }
</script>
